module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-300-light-a801572a74b8eae6725c0b02e46e2d6a.woff2";